




























import Vue from 'vue';
import { notify, AsyncBtn } from 'mycorems-app-shared';
import isGranted from '@/auth/isGranted';
import {
  ExternalCampaign, FetchEmailCampaignsFilters, ExternalCampaignsTableElement,
} from '@/types';
import { fetch } from './email-campaign';
import ExternalCampaignsTable from './ExternalCampaignsTable.vue';

interface Data {
  task: Promise<void>|null,
  selectedCampaignIds: string[],
}

export default Vue.extend({
  props: {
    clientId: {
      type: String,
      required: true,
    },
  },
  data(): Data {
    return {
      task: null,
      selectedCampaignIds: [],
    };
  },
  computed: {
    retrieveBtnLabel(): string {
      if (!this.selectedCampaignIds.length) return 'Retrieve';
      return `Retrieve (${this.selectedCampaignIds.length})`;
    },
    multipleSelected(): boolean {
      return (this.selectedCampaignIds.length > 1);
    },
    filters(): FetchEmailCampaignsFilters {
      return {
        ids: this.selectedCampaignIds,
      };
    },
  },
  methods: {
    selectCampaigns(campaigns: ExternalCampaign[]): void {
      this.selectedCampaignIds = campaigns.map(c => c.id);
    },
    fetch(): void {
      this.task = fetch(this.clientId, this.filters);
      this.task.then(() => {
        (this.$refs.externalCampaignsTable as ExternalCampaignsTableElement).load();
        notify.success(
          `(${this.selectedCampaignIds.length}) Email campaign${(this.multipleSelected) ? 's' : ''}
           retrieved.`,
        );
        this.selectedCampaignIds = [];
      });
    },
    isGranted,
  },
  components: {
    'external-campaigns-table': ExternalCampaignsTable,
    'async-btn': AsyncBtn,
  },
});
